import React, { Component } from 'react';
import * as api from '../../services/api/auth';

class Logout extends Component {
  async componentDidMount() {
    try {
      await api.logoutUser();
      sessionStorage.removeItem('redirect1');
      sessionStorage.removeItem('redirect2');
      localStorage.removeItem('pathRedirect');
      localStorage.removeItem('pathUrl');
      localStorage.removeItem('info');
    } finally {
      window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    }
  }

  render() {
    return <>Logging you out...</>;
  }
}

export default Logout;
